import { queryBuilder } from '@inpart-io/devtools-iap';
import { RETRIEVE_BY_QUERY } from '@inpart-io/devtools-vue';
import { type IPrivateContactAlliance } from '@inpart-io/padme-iap';
import { type ActionTree } from 'vuex';

import { RECEIVE_BY_ALLIANCE } from './mutations';

export const STORE_BY_ALLIANCE = 'storeByAlliance';
export const RETRIEVE_BY_ALLIANCE = 'retrieveByAlliance';

export const actions: ActionTree<IPrivateContactAlliance, unknown> = {
    async [RETRIEVE_BY_ALLIANCE](context, { allianceId, properties }: { allianceId: number; properties?: string }): Promise<number[]> {
        const idList = await context.dispatch(RETRIEVE_BY_QUERY, {
            query: queryBuilder.build(queryBuilder.op.and(queryBuilder.cmp.refersTo('alliance', allianceId))),
            properties
        });
        context.commit(RECEIVE_BY_ALLIANCE, { allianceId, idList });
        return idList;
    },
    [STORE_BY_ALLIANCE](context, { allianceId, idList }: { allianceId: number; idList: number[] }): void {
        context.commit(RECEIVE_BY_ALLIANCE, { allianceId, idList });
    }
};
